import { Component } from 'react'
import styled from 'glamorous'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { graphql } from 'react-apollo'

import { $, div } from 'utils'
import { map, find } from 'lodash'
import { Icon, HeaderRow, Checkbox, Loader, Tooltip, Button } from 'components'
import { DESCRIPTOR_LISTS, PERSON_LISTS } from 'queries'

import PanelSearchInput from './PanelSearchInput'

const AnimatedContainer = styled.div({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  background: '#fff',
  zIndex: 2,
  transform: 'translateX(100%)',
  animation: 'var(--animationSlideIn)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideOut)',
}), 'AddListPanel')

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: 'white',
  overflow: 'hidden',
}, 'cls-container')

const MatchingContainer = styled.div({
  position: 'absolute',
  height: '100%',
  width: '100%',
}, 'cls-matchContainer')

const InputContainer = styled.div({
  marginTop: 20
})

const InnerContainer = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 30px',
})

const ListContainer = styled.div({
  maringTop: 20
})

const ListItem = styled.div({
  padding: '20px 0',
  borderBottom: 'var(--border)',
  display: 'flex',
  alignItems: 'flex-start'
})

const ListInfo = styled.div({
  marginLeft: 15,
})

const ListName = styled.div({
  fontSize: 14,
  fontWeight: 'bold'
})

const ListId = styled.div({
  fontSize: 14,
  color: 'var(--grey)'
})

const BottomBar = styled.div({
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 20
})


class TypedList extends Component {

  // todo: need fix local offset on data.variables.offset
  // https://github.com/apollographql/apollo-client/issues/2499
  componentWillMount() {
    this.setState({ offset: this.props.data.variables.offset })
  }

  fetchMore = () => {
    this.setState({ offset: this.state.offset + 1 }, () =>
      this.props.data.fetchMore({
        variables: {
          offset: this.state.offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const list = this.props.type === 'persons' ? 'personsLists' : 'descriptorsLists'
          const newItems = [...prev[list].items, ...fetchMoreResult[list].items]
          return {...prev, [list]: { ...prev[list], items: newItems }}
        }
      })
    )
  }

  render() {
    const { selected, type, onSelect, data: { loading, descriptorsLists, personsLists }, searchItems } = this.props
    if (loading && !descriptorsLists && !personsLists) return $(Loader)

    const list = type === 'persons' ? personsLists : descriptorsLists
    const items = searchItems.length > 0 ? searchItems : (type === 'persons' ? personsLists.items : descriptorsLists.items)
    return (
      div(
        $(ListContainer, map(items, (list) =>
          $(ListItem, { key: list.uuid },
            $(Checkbox, {
              selected: !!find(selected, s => s.uuid === list.uuid),
              onChange: () => onSelect(list),
              label: $(ListInfo, $(ListName, list.listData), $(ListId, list.uuid))
            }),
          )
        )),
        list.items.length < list.count && searchItems.length === 0 &&
          $(BottomBar,
            $(Button, {
              onClick: this.fetchMore,
              bgColor: '#9a9af2',
              primary: true,
              width: '185px',
            }, 'Show more'),
          )
      )
    )
  }
}

const options = {
  options: props => {
    return {
      fetchPolicy: 'cache-and-network',
      variables: getVariables(),
    }
  }
}
const PersonList =  graphql(PERSON_LISTS, options)(TypedList)
const DescriptorList =  graphql(DESCRIPTOR_LISTS, options)(TypedList)


class AddListPanel extends Component {

  state = {
    selected: this.props.selected || [],
    initialSelected: this.props.selected || [],
    searchItems: [],
    shown: true,
  }

  static defaultProps = {
    type: 'persons' // persons | descriptors
  }

  // TODO React 16 lifecycles do not recommend using componentWillReceiveProps
  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      this.setState({selected: nextProps.selected})
    }
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.onClose() }, 300)
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state.selected)
    this.close()
  }

  handleSelect = (list) => {
    const { selected } = this.state
    const { single } = this.props
    if (!selected.find(l => l.uuid === list.uuid))
      this.setState({ selected: (single) ? [list] : selected.concat(list) })
    else
      this.setState({ selected: selected.filter(l => list.uuid !== l.uuid) })
  }

  handleSearch = (item) => {
    const { searchItems } = this.state
    if (!searchItems.find(s => s.uuid === item.uuid)) {
      this.setState({ searchItems: searchItems.concat(item) })
    }
  }

  render = () => {
    const { type } = this.props
    const { selected, initialSelected, searchItems, shown } = this.state

    return (
      $(AnimatedContainer, { shown },
        $(Container,
          $(MatchingContainer,
            $(InnerContainer,
              $(HeaderRow, {
                  label: 'Add lists',
                  onLabelClick: this.close,
                  clickable: true,
                  withArrow: true
                },
                $(Tooltip, { tip: 'Done' },
                  $(Icon, {
                    type: 'done',
                    isDisabled: selected.length === 0 && initialSelected.length === 0,
                    isActive: selected.length > 0 || initialSelected.length > 0,
                    onClick: this.handleSubmit
                  })
                )
              ),
              $(InputContainer, $(PanelSearchInput, { targetType: 'list', onChange: this.handleSearch })),
              type === 'persons'
                ? $(PersonList, {
                    onSelect: this.handleSelect,
                    type, selected,
                    searchItems
                  })
                : $(DescriptorList, {
                    onSelect: this.handleSelect,
                    type,
                    selected,
                    searchItems
                  })
            ),
          ),
        )
      )
    )
  }
}

export default AddListPanel


const getVariables = (queryParams = {}) => ({
  limit: queryParams.limit || 7,
  offset: queryParams.offset || 1,
})



// WEBPACK FOOTER //
// ./src/components/panels/AddListPanel.js